import * as React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';

import {
    ArgumentAxis, Chart, SplineSeries, ValueAxis
} from '@devexpress/dx-react-chart-material-ui';
import Paper from '@material-ui/core/Paper';

import { withDefaultStyles } from '../../../utils/material-ui/hoc';

class Integrations extends React.Component<any, any> {
  public render() {
    const generateData = (start: number, end: number, step: number) => {
      const data: any[] = [];
      for (let i = start; i < end; i += step) {
        data.push({
          value: Math.sin(i) / i,
          argument: i
        });
      }
      return data;
    };
    return (
      <div style={this.props.style}>
        <Paper>
          <Chart
              data={generateData(2.5, 12, 0.5)} width={650} height={500}>
            <ArgumentAxis showGrid={true} />
            <ValueAxis />

            <SplineSeries valueField="value" argumentField="argument" />
          </Chart>
        </Paper>
      </div>
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  return { ...state };
}

export default withDefaultStyles(withRouter(connect(
  mapStateToProps,
)(Integrations)));



// WEBPACK FOOTER //
// ./src/sub-projects/reports/containers/content.tsx